var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0003 80C61.819 80 79.5065 62.0914 79.5065 40C79.5065 17.9086 61.819 0 40.0003 0C18.1817 0 0.494141 17.9086 0.494141 40C0.494141 62.0914 18.1817 80 40.0003 80Z",
    fill: "#FAEAE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.747 49.0689L39.8493 31.5469L7.90039 49.0689V51.3498L39.8493 68.8718L71.747 51.3498V49.0689Z",
    fill: "#B4B4B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.747 49.0689L39.8493 66.539L7.90039 49.0689L39.8493 31.5469L71.747 49.0689Z",
    fill: "#DDDDDD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.399 49.0692L39.8501 63.0661L14.25 49.0692L39.8501 35.0205L65.399 49.0692Z",
    fill: "#DA674E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8477 66.5395V68.8723L71.7454 51.3503V49.0693L39.8477 66.5395Z",
    fill: "#888888"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8195 39.2711L52.4466 35.2275L45.125 39.2711V49.017L52.4466 53.0606L59.8195 49.017V39.2711Z",
    fill: "#DDDDDD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8195 39.2711L52.4466 43.2628L45.125 39.2711L52.4466 35.2275L59.8195 39.2711Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4492 43.2632V53.061L59.822 49.0174V39.2715L52.4492 43.2632Z",
    fill: "#B4B4B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.191 31.9097L29.8181 27.8662L22.4453 31.9097V48.8097L29.8181 52.8532L37.191 48.8097V31.9097Z",
    fill: "#DDDDDD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.191 31.9097L29.8181 35.9014L22.4453 31.9097L29.8181 27.8662L37.191 31.9097Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8184 35.9019V52.8536L37.1912 48.8101V31.9102L29.8184 35.9019Z",
    fill: "#B4B4B4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2496 14.5435L40.8767 10.5L33.5039 14.5435V55.0307L40.8767 59.0743L48.2496 55.0307V14.5435Z",
    fill: "#DDDDDD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2496 14.5435L40.8767 18.5871L33.5039 14.5435L40.8767 10.5L48.2496 14.5435Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40.875 18.5875V59.0747L48.2478 55.0312V14.5439L40.875 18.5875Z",
    fill: "#B4B4B4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporationIcon);
export default __webpack_public_path__ + "static/media/corporation-icon.96c1617b0e1237cd492efed25d9f1573.svg";
export { ForwardRef as ReactComponent };